import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/apps/:appType" element={<DefaultConsumerLayout />}>
    <Route path="consumer/apps/:appType" element={<AsyncPage />} />
  </Route>
);
